var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgArrowDown = function SvgArrowDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 7,
    fill: "#949191",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.008.918a.37.37 0 0 1 .629-.26L5.54 5.559l4.83-4.83a.37.37 0 0 1 .52 0 .37.37 0 0 1 0 .521L5.8 6.34a.37.37 0 0 1-.52 0L.116 1.18a.37.37 0 0 1-.108-.26Z",
    fill: "current"
  })));
};

export default SvgArrowDown;